import { S127gS127m01Component } from './s127g-s127m01.component';

export { S127gModule } from './s127g.module';

export const S127gSubComponentsMap = {
	
};

export const S127gComponentsMap = {
	"s127g-s127m01": S127gS127m01Component
};

export const S127gComponents = [
	S127gS127m01Component
];

